/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.1.3 routes of Church::Application.
 * @version 534df1574d871a8699e40aec4d714aa8ebf6f49c641f6886f07820a07ba0006d
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    false
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:id/abandon(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const abandon_resource_upgrade_cycle_item = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"abandon"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_action_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const action_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_action_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"active-storage-dashboard"]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/attachments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_attachment = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_attachments = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/blobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_blob = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"blobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/blobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_blobs = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"blobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/attachments/:id/download(/:disposition)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_download_attachment = /*#__PURE__*/ __jsr.r({"id":{"r":true},"disposition":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[1,[2,[7,"/"],[3,"disposition"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/blobs/:id/download(/:disposition)(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_download_blob = /*#__PURE__*/ __jsr.r({"id":{"r":true},"disposition":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"blobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[2,[1,[2,[7,"/"],[3,"disposition"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_root = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/variant_records/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_variant_record = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"variant_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /active-storage-dashboard/variant_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const active_storage_dashboard_variant_records = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"active-storage-dashboard"]],[7,"/"]],[2,[6,"variant_records"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feature_flags/:id/add_entry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_entry_feature_flag = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_entry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/circle_dashboards/:circle_id/add_funds(.:format)
 * @param {any} circle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_funds_finance_circle_dashboard = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"circle_dashboards"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"add_funds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_care_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/remote_debugging_executions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_remote_debugging_executions = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"remote_debugging_executions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/remote_debugging/user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_remote_debugging_user = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"remote_debugging"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_spiritual_event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/user_actions_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_user_actions_logs = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"user_actions_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_stats = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"stats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/time_spent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_time_spent = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"time_spent"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id/apprentices_pane(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprentices_pane_scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"apprentices_pane"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeships/:apprenticeship_id/apprenticeship_crafts(.:format)
 * @param {any} apprenticeship_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_apprenticeship_crafts = /*#__PURE__*/ __jsr.r({"apprenticeship_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeships"],[2,[7,"/"],[2,[3,"apprenticeship_id"],[2,[7,"/"],[2,[6,"apprenticeship_crafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeships/:apprenticeship_id/apprenticeship_focuses(.:format)
 * @param {any} apprenticeship_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_apprenticeship_focuses = /*#__PURE__*/ __jsr.r({"apprenticeship_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeships"],[2,[7,"/"],[2,[3,"apprenticeship_id"],[2,[7,"/"],[2,[6,"apprenticeship_focuses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeships/:apprenticeship_id/apprenticeship_resources(.:format)
 * @param {any} apprenticeship_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_apprenticeship_resources = /*#__PURE__*/ __jsr.r({"apprenticeship_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeships"],[2,[7,"/"],[2,[3,"apprenticeship_id"],[2,[7,"/"],[2,[6,"apprenticeship_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeships/:apprenticeship_id/apprenticeship_users(.:format)
 * @param {any} apprenticeship_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_apprenticeship_users = /*#__PURE__*/ __jsr.r({"apprenticeship_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeships"],[2,[7,"/"],[2,[3,"apprenticeship_id"],[2,[7,"/"],[2,[6,"apprenticeship_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_crafts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_craft = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_crafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_focuses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_focuse = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_focuses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_resource = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_resources/:apprenticeship_resource_id/apprenticeship_resource_users(.:format)
 * @param {any} apprenticeship_resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_resource_apprenticeship_resource_users = /*#__PURE__*/ __jsr.r({"apprenticeship_resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_resources"],[2,[7,"/"],[2,[3,"apprenticeship_resource_id"],[2,[7,"/"],[2,[6,"apprenticeship_resource_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_resource_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_resource_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_resource_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apprenticeship_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /training_map_attachments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_map_attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /attachment_resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attachment_resource = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachment_resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bolls/books/:book_id/chapters/:chapter/verses(.:format)
 * @param {any} book_id
 * @param {any} chapter
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bolls_book_chapter_verses = /*#__PURE__*/ __jsr.r({"book_id":{"r":true},"chapter":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bolls"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"book_id"],[2,[7,"/"],[2,[6,"chapters"],[2,[7,"/"],[2,[3,"chapter"],[2,[7,"/"],[2,[6,"verses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bolls/books/:book_id/chapters(.:format)
 * @param {any} book_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bolls_book_chapters = /*#__PURE__*/ __jsr.r({"book_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bolls"],[2,[7,"/"],[2,[6,"books"],[2,[7,"/"],[2,[3,"book_id"],[2,[7,"/"],[2,[6,"chapters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bolls/books(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bolls_books = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bolls"],[2,[7,"/"],[2,[6,"books"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /buckets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bucket = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /buckets/:bucket_id/transactions(.:format)
 * @param {any} bucket_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bucket_transactions = /*#__PURE__*/ __jsr.r({"bucket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[3,"bucket_id"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_inputs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_input = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_inputs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_input_care_processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_input_care_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_input_care_processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_input_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_input_type = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_input_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:care_process_id/care_process_steps(.:format)
 * @param {any} care_process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_care_process_steps = /*#__PURE__*/ __jsr.r({"care_process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"care_process_id"],[2,[7,"/"],[2,[6,"care_process_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:care_process_id/care_process_text_recipients(.:format)
 * @param {any} care_process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_care_process_text_recipients = /*#__PURE__*/ __jsr.r({"care_process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"care_process_id"],[2,[7,"/"],[2,[6,"care_process_text_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:care_process_id/care_process_users(.:format)
 * @param {any} care_process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_care_process_users = /*#__PURE__*/ __jsr.r({"care_process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"care_process_id"],[2,[7,"/"],[2,[6,"care_process_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:care_process_id/chats(.:format)
 * @param {any} care_process_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_chats = /*#__PURE__*/ __jsr.r({"care_process_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"care_process_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_empowerments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_empowerment = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_empowerments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_maps/:care_process_map_id/care_process_empowerments(.:format)
 * @param {any} care_process_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_map_care_process_empowerments = /*#__PURE__*/ __jsr.r({"care_process_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[3,"care_process_map_id"],[2,[7,"/"],[2,[6,"care_process_empowerments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_maps/:care_process_map_id/care_process_map_steps(.:format)
 * @param {any} care_process_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_map_care_process_map_steps = /*#__PURE__*/ __jsr.r({"care_process_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[3,"care_process_map_id"],[2,[7,"/"],[2,[6,"care_process_map_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_map_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_map_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_map_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_steps/:care_process_step_id/care_process_step_owners(.:format)
 * @param {any} care_process_step_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_step_care_process_step_owners = /*#__PURE__*/ __jsr.r({"care_process_step_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_steps"],[2,[7,"/"],[2,[3,"care_process_step_id"],[2,[7,"/"],[2,[6,"care_process_step_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_step_owners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_step_owner = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_step_owners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_text_recipients/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_text_recipient = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_text_recipients"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const care_process_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_books/:id/chapters(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chapters_scripture_book = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_books"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chapters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:id/chat(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_care_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/chat(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chat_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"chat"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/check_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_token_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"check_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /circles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /circles/:circle_id/admin_gathering_role/:gathering_id/:role_type_id/:gathering_role_id(.:format)
 * @param {any} circle_id
 * @param {any} gathering_id
 * @param {any} role_type_id
 * @param {any} gathering_role_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_admin_gathering_role = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"gathering_id":{"r":true},"role_type_id":{"r":true},"gathering_role_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"admin_gathering_role"],[2,[7,"/"],[2,[3,"gathering_id"],[2,[7,"/"],[2,[3,"role_type_id"],[2,[7,"/"],[2,[3,"gathering_role_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /circles/:circle_id/gathering_roles/:gathering_id(.:format)
 * @param {any} circle_id
 * @param {any} gathering_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_gathering_roles = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"gathering_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"gathering_roles"],[2,[7,"/"],[2,[3,"gathering_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /circles/:circle_id/menu/:panel(.:format)
 * @param {any} circle_id
 * @param {any} panel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_menu = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"panel":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"menu"],[2,[7,"/"],[2,[3,"panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /circles/:circle_id/partial/:partial(.:format)
 * @param {any} circle_id
 * @param {any} partial
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_partial = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"partial":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"partial"],[2,[7,"/"],[2,[3,"partial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /circles/:circle_id/roles(.:format)
 * @param {any} circle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_roles = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /circles/:circle_id/toggle_role_type/:role_type_id/:method(.:format)
 * @param {any} circle_id
 * @param {any} role_type_id
 * @param {any} method
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_toggle_role_type = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"role_type_id":{"r":true},"method":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"toggle_role_type"],[2,[7,"/"],[2,[3,"role_type_id"],[2,[7,"/"],[2,[3,"method"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /circle_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_type = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circle_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /circle_types/:circle_type_id/iterate(.:format)
 * @param {any} circle_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const circle_type_iterate = /*#__PURE__*/ __jsr.r({"circle_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circle_types"],[2,[7,"/"],[2,[3,"circle_type_id"],[2,[7,"/"],[2,[6,"iterate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/cleanse_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cleanse_token_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"cleanse_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_inputs/:id/clear_no_action(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_no_action_care_input = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_inputs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_no_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/clear_targets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clear_targets_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/periods/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_finance_period = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"periods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycles/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_resource_upgrade_cycle = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placements/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_scripture_dig_tool_placement = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tool_placements/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_spiritual_event_tool_placement = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tool_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/close(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const close_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collaborations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaboration = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /collaborations/:collaboration_id/collaboration_events(.:format)
 * @param {any} collaboration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaboration_events = /*#__PURE__*/ __jsr.r({"collaboration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborations"],[2,[7,"/"],[2,[3,"collaboration_id"],[2,[7,"/"],[2,[6,"collaboration_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collaborations/:collaboration_id/collaboration_members(.:format)
 * @param {any} collaboration_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaboration_members = /*#__PURE__*/ __jsr.r({"collaboration_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborations"],[2,[7,"/"],[2,[3,"collaboration_id"],[2,[7,"/"],[2,[6,"collaboration_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_completions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completion = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_completions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/completions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const completions_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /components/:component_id/state(.:format)
 * @param {any} component_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_change_state = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:component_id/component_fields/:id(.:format)
 * @param {any} component_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_field = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"component_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:component_id/component_fields/:field_id/component_data(.:format)
 * @param {any} component_id
 * @param {any} field_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_field_data = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"field_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"component_fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"component_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:component_id/component_fields/:field_id/component_data/:id(.:format)
 * @param {any} component_id
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_field_datum = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"component_fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"component_data"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:component_id/component_fields(.:format)
 * @param {any} component_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_fields = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"component_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /component_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_type = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"component_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /component_types/:component_type_id/component_fields/:id(.:format)
 * @param {any} component_type_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_type_field = /*#__PURE__*/ __jsr.r({"component_type_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"component_types"],[2,[7,"/"],[2,[3,"component_type_id"],[2,[7,"/"],[2,[6,"component_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /component_types/:component_type_id/component_fields(.:format)
 * @param {any} component_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_type_fields = /*#__PURE__*/ __jsr.r({"component_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"component_types"],[2,[7,"/"],[2,[3,"component_type_id"],[2,[7,"/"],[2,[6,"component_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /component_types/:component_type_id/select(.:format)
 * @param {any} component_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_type_select = /*#__PURE__*/ __jsr.r({"component_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"component_types"],[2,[7,"/"],[2,[3,"component_type_id"],[2,[7,"/"],[2,[6,"select"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /component_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const component_types = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"component_types"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /components(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const components = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"components"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflections/:id/conclude(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const conclude_scripture_study_reflection = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"conclude"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_users/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_care_process_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_map_contents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_map_contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /content_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const content_page = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_entries/:id/coordinates(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coordinates_spiritual_practice_entry = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"coordinates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /skill_models/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_skill_model = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"skill_models"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:id/copy(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const copy_training_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /crafts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /craft_aspects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_aspect = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"craft_aspects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crafts/:craft_id/craft_aspects(.:format)
 * @param {any} craft_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_craft_aspects = /*#__PURE__*/ __jsr.r({"craft_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[3,"craft_id"],[2,[7,"/"],[2,[6,"craft_aspects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /crafts/:craft_id/craft_eligibilities(.:format)
 * @param {any} craft_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_craft_eligibilities = /*#__PURE__*/ __jsr.r({"craft_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[3,"craft_id"],[2,[7,"/"],[2,[6,"craft_eligibilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /crafts/:craft_id/craft_resources(.:format)
 * @param {any} craft_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_craft_resources = /*#__PURE__*/ __jsr.r({"craft_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[3,"craft_id"],[2,[7,"/"],[2,[6,"craft_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /craft_eligibilities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_eligibility = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"craft_eligibilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /craft_resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_resource = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"craft_resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /craft_resource_aspects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_resource_aspect = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"craft_resource_aspects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /craft_resources/:craft_resource_id/craft_resource_aspects(.:format)
 * @param {any} craft_resource_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const craft_resource_craft_resource_aspects = /*#__PURE__*/ __jsr.r({"craft_resource_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"craft_resources"],[2,[7,"/"],[2,[3,"craft_resource_id"],[2,[7,"/"],[2,[6,"craft_resource_aspects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramage_maps/create_daily_rule_sample(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_daily_rule_sample_ecosystem_pilgramage_maps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramage_maps"],[2,[7,"/"],[2,[6,"create_daily_rule_sample"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/create_passage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_passage_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_passage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teaching_guide_criteria/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const criterium = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teaching_guide_criteria"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/debrief(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debrief_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"debrief"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/debug/declarative_web_push(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_declarative_web_push_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"declarative_web_push"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/debug/firebase(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const debug_firebase_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"debug"],[2,[7,"/"],[2,[6,"firebase"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/chats(.:format)
 * @param {any} decision_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_chats = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decision_contributors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_contributor = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decision_contributors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/decision_contributors(.:format)
 * @param {any} decision_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_decision_contributors = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"decision_contributors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/decision_input_points(.:format)
 * @param {any} decision_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_decision_input_points = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"decision_input_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/decision_questions(.:format)
 * @param {any} decision_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_decision_questions = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"decision_questions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decision_input_points/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_input_point = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decision_input_points"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/input_type_form/:input_type_id(.:format)
 * @param {any} decision_id
 * @param {any} input_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_input_type_form = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"input_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"input_type_form"],[2,[7,"/"],[2,[3,"input_type_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/interact_pane/:tab(.:format)
 * @param {any} decision_id
 * @param {any} tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_interact_pane = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"interact_pane"],[2,[7,"/"],[2,[3,"tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /decision_questions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decision_question = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decision_questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /declarative-web-push-sw.js(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const declarative_web_push_service_worker = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"declarative-web-push-sw"],[2,[8,"."],[2,[6,"js"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notification_preferences/devices(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const devices_user_notification_preferences = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notification_preferences"],[2,[7,"/"],[2,[6,"devices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_map_dig_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_map_dig_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/discipleship_journey_action_steps(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_action_steps = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"discipleship_journey_action_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/choose_role/:map_role_id(.:format)
 * @param {any} discipleship_journey_id
 * @param {any} map_role_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_choose_role = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"map_role_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"choose_role"],[2,[7,"/"],[2,[3,"map_role_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/discipleship_journey_completions(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_completions = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"discipleship_journey_completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/discipleship_journey_modules(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_discipleship_journey_modules = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"discipleship_journey_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/discipleship_journey_roles(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_discipleship_journey_roles = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"discipleship_journey_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/edit_journey_note(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_edit_journey_note = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"edit_journey_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_modules/:id(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_module = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_modules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_modules(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_modules = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles/:id(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_role = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles/:role_id/discipleship_journey_map_role_completion_tasks/:id(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} role_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_role_completion_task = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"role_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[2,[7,"/"],[2,[3,"role_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_role_completion_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles/:role_id/discipleship_journey_map_role_completion_tasks(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} role_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_role_completion_tasks = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"role_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[2,[7,"/"],[2,[3,"role_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_role_completion_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles/:role_id/discipleship_journey_map_role_contingencies(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} role_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_role_contingencies = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"role_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[2,[7,"/"],[2,[3,"role_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_role_contingencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles/:role_id/discipleship_journey_map_role_contingencies/:id(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} role_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_role_contingency = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"role_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[2,[7,"/"],[2,[3,"role_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_role_contingencies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_map_roles = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_maps = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/menu/:panel(.:format)
 * @param {any} discipleship_journey_id
 * @param {any} panel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_menu = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"panel":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"menu"],[2,[7,"/"],[2,[3,"panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_modules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_module = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_modules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/discipleship_journey_module_completions(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_module_completions = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"discipleship_journey_module_completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/module_preview/:module_id(.:format)
 * @param {any} discipleship_journey_id
 * @param {any} module_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_module_preview = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"module_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"module_preview"],[2,[7,"/"],[2,[3,"module_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/discipleship_journey_modules(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_modules = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"discipleship_journey_modules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/render_status(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_render_status = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"render_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/role_stamp/:map_role_id(.:format)
 * @param {any} discipleship_journey_id
 * @param {any} map_role_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_role_stamp = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"map_role_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"role_stamp"],[2,[7,"/"],[2,[3,"map_role_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/discipleship_journey_roles(.:format)
 * @param {any} discipleship_journey_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_roles = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"discipleship_journey_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/toggle_map_role/:map_role_id(.:format)
 * @param {any} discipleship_journey_id
 * @param {any} map_role_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_toggle_map_role = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"map_role_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"toggle_map_role"],[2,[7,"/"],[2,[3,"map_role_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:discipleship_journey_id/user_progress/:user_id/:can_drop(.:format)
 * @param {any} discipleship_journey_id
 * @param {any} user_id
 * @param {any} can_drop
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discipleship_journey_user_progress = /*#__PURE__*/ __jsr.r({"discipleship_journey_id":{"r":true},"user_id":{"r":true},"can_drop":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"discipleship_journey_id"],[2,[7,"/"],[2,[6,"user_progress"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[3,"can_drop"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drawer_buttons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drawer_button = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drawer_buttons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /drawer_buttons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drawer_buttons = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drawer_buttons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ecosystem_admins/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_admin = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystem_admins"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_announcement = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:ecosystem_announcement_id/ecosystem_announcement_closures(.:format)
 * @param {any} ecosystem_announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_announcement_closures = /*#__PURE__*/ __jsr.r({"ecosystem_announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"ecosystem_announcement_id"],[2,[7,"/"],[2,[6,"ecosystem_announcement_closures"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/apprenticeships(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_apprenticeships = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"apprenticeships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/attachment_resources(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_attachment_resources = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"attachment_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/bible(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_bible_reader = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"bible"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/bible/chapter(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_bible_reader_chapter = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"bible"],[2,[7,"/"],[2,[6,"chapter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/bible/placement(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_bible_reader_placement = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"bible"],[2,[7,"/"],[2,[6,"placement"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/buckets(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_buckets = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"buckets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/care_input_care_processes(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_care_input_care_processes = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"care_input_care_processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/care_input_types(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_care_input_types = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"care_input_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/care_inputs(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_care_inputs = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"care_inputs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/care_process_maps(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_care_process_maps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"care_process_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/care_processes(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_care_processes = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"care_processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/circle_types(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_circle_types = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"circle_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/circles(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_circles = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"circles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/collaborations(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_collaborations = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"collaborations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/content_pages(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_content_pages = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"content_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/crafts(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_crafts = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"crafts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/dashboard/:resource(.:format)
 * @param {any} ecosystem_id
 * @param {any} resource
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_dashboard = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"resource":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[3,"resource"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/decisions(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_decisions = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"decisions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/discipleship_journeys(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_discipleship_journeys = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"discipleship_journeys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/ecosystem_admins(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_ecosystem_admins = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"ecosystem_admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/announcements(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_ecosystem_announcements = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/ecosystem_input_data(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_ecosystem_input_data = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"ecosystem_input_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/ecosystems_users(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_ecosystems_users = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"ecosystems_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/farewell_messages(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_farewell_messages = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"farewell_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gathering_absences(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_gathering_absences = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gathering_absences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gathering_map_gathering_roles(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_gathering_map_gathering_roles = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gathering_map_gathering_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gathering_maps(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_gathering_maps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gathering_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gathering_roles(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_gathering_roles = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gathering_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gathering_sections(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_gathering_sections = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gathering_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gatherings(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_gatherings = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gatherings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/home(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_home = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/home/:section(.:format)
 * @param {any} ecosystem_id
 * @param {any} section
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_home_section = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"section":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[3,"section"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/home/:section/:subsection(.:format)
 * @param {any} ecosystem_id
 * @param {any} section
 * @param {any} subsection
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_home_section_subsection = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"section":{"r":true},"subsection":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[3,"section"],[2,[7,"/"],[2,[3,"subsection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystem_input_data/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_input_datum = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystem_input_data"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/kingdom_immersion(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_kingdom_immersion = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"kingdom_immersion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/people_process_roles(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_people_process_roles = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"people_process_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/people_process_step_owners(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_people_process_step_owners = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"people_process_step_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/people_process_steps(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_people_process_steps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"people_process_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/people_processes(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_people_processes = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"people_processes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramage_activities(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pilgramage_activities = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramage_activities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramage_maps(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pilgramage_maps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramage_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramage_step_completions(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pilgramage_step_completions = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramage_step_completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramage_teaching_completions(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pilgramage_teaching_completions = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramage_teaching_completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramage_users(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pilgramage_users = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramage_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramages(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pilgramages = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/prayer_request_viewers(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_prayer_request_viewers = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"prayer_request_viewers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/prayer_requests(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_prayer_requests = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"prayer_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/prayer_sessions(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_prayer_sessions = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"prayer_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/process_templates(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_process_templates = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"process_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pulses(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pulses = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pulses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/download(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_pwa_install_instructions = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/render_drawer(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_render_drawer = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"render_drawer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/resource_upgrade_cycles(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_resource_upgrade_cycles = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"resource_upgrade_cycles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/resources(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_resources = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/role_types(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_role_types = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"role_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_chapters(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_chapters = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_chapters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_dig_info_pages(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_dig_info_pages = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_dig_info_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_dig_maps(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_dig_maps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_dig_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_dig_tools(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_dig_tools = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_dig_tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_digs(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_digs = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_digs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_imports(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_imports = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_studies(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_studies = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_studies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_study_maps(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_scripture_study_maps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_study_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/ecosystem_seasons(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_season_index = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"ecosystem_seasons"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/skill_models(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_skill_models = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"skill_models"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/spiritual_event_tools(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_spiritual_event_tools = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"spiritual_event_tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/spiritual_events(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_spiritual_events = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"spiritual_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/spiritual_practice_milestones(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_spiritual_practice_milestones = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"spiritual_practice_milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/spiritual_practices(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_spiritual_practices = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"spiritual_practices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pings/tab(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_tab_ping = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pings"],[2,[7,"/"],[2,[6,"tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/teaching_guides(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_teaching_guides = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"teaching_guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/training_maps(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_training_maps = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"training_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/training_trees(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_training_trees = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"training_trees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/trainings(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_trainings = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"trainings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/user_challenges(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_user_challenges = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"user_challenges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/user_empowerments(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_user_empowerments = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"user_empowerments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/user_kind_assignments(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_user_kind_assignments = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"user_kind_assignments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/user_kinds(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_user_kinds = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"user_kinds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/user_reminder(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_user_reminder = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"user_reminder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/users(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystem_users = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ecosystems_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ecosystems_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeships/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_apprenticeship = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeships"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_resources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_apprenticeship_resource = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /buckets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bucket = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_inputs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_care_input = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_inputs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_care_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_maps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_care_process_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_map_steps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_care_process_map_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_map_steps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_steps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_care_process_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_steps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chats/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_chat = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chats"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /circles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_circle = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /circle_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_circle_type = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circle_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collaborations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_collaboration = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_component = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:component_id/component_fields/:field_id/component_data/:id/edit(.:format)
 * @param {any} component_id
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_component_field_datum = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"component_fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"component_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /content_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_content_page = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"content_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /crafts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_craft = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /craft_aspects/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_craft_aspect = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"craft_aspects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /craft_resources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_craft_resource = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"craft_resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_decision = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decision_input_points/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_decision_input_point = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decision_input_points"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /decision_questions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_decision_question = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decision_questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journeys/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_discipleship_journey = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_discipleship_journey_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_modules/:id/edit(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_discipleship_journey_map_module = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_modules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles/:id/edit(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_discipleship_journey_map_role = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drawer_buttons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_drawer_button = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"drawer_buttons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_ecosystem = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /farewell_messages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_farewell_message = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"farewell_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feature_flags/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_feature_flag = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/buckets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_finance_bucket = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/gifts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_finance_gift = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/periods/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_finance_period = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"periods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_gathering = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_maps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_gathering_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_map_gathering_roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_gathering_map_gathering_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_map_gathering_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_gathering_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_gathering_section = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /menu_buttons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_menu_button = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"menu_buttons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /menu_sections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_menu_section = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"menu_sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflections/:id/edit_name(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_name_scripture_study_reflection = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_inputs/:id/edit_no_action_note(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_no_action_note_care_input = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_inputs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_no_action_note"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_note = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflection_evaluations/:id/edit_notes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_notes_reflection_evaluation = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflection_evaluations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_notification = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_maps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pilgramage_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_post = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post_replies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_post_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_replies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /prayer_requests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_prayer_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /prayer_request_updates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_prayer_request_update = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_request_updates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pulses/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_pulse = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pulses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflection_impacts/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_reflection_impact = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflection_impacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_registered_roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_registered_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_registered_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resources/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_resource = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /roles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /role_types/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_role_type = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_types"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /role_type_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_role_type_item = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_type_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_notifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scheduled_notification = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scheduled_notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_info_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_dig_info_page = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_info_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_digs/:scripture_dig_id/progress/edit(.:format)
 * @param {any} scripture_dig_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_dig_progress = /*#__PURE__*/ __jsr.r({"scripture_dig_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_digs"],[2,[7,"/"],[2,[3,"scripture_dig_id"],[2,[7,"/"],[2,[6,"progress"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tools/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_dig_tool = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_dig_tool_placement = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placement_replies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_dig_tool_placement_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placement_replies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_maps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_scripture_study_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystem_seasons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_season = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystem_seasons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /skill_models/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_skill_model = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"skill_models"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spiritual_event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tools/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spiritual_event_tool = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tool_placements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spiritual_event_tool_placement = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tool_placements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tool_placement_replies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spiritual_event_tool_placement_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tool_placement_replies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_entries/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spiritual_practice_entries = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_entries"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_entries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spiritual_practice_entry = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_milestones/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_spiritual_practice_milestone = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /tags/edit/:target_id(.:format)
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_tags = /*#__PURE__*/ __jsr.r({"target_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teaching_guides/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_teaching_guide = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teaching_guides"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /timegated/edit/:target_id/:target_type(.:format)
 * @param {any} target_id
 * @param {any} target_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_timegated_index = /*#__PURE__*/ __jsr.r({"target_id":{"r":true},"target_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timegated"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"target_id"],[2,[7,"/"],[2,[3,"target_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_groups/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_training_group = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_groups"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_training_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_map_debrief_points/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_training_map_debrief_point = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_map_debrief_points"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_trees/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_training_tree = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_trees"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /transactions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_transaction = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"transactions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_challenges/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_challenge = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_challenge_targets/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_challenge_target = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_challenge_targets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_kinds/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_kind = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_kinds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_chapters/:id/verses/:verse_id/edit(.:format)
 * @param {any} id
 * @param {any} verse_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_verse_scripture_chapter = /*#__PURE__*/ __jsr.r({"id":{"r":true},"verse_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_chapters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verses"],[2,[7,"/"],[2,[3,"verse_id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /training_map_editors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editor = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_map_editors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_crafts/:id/evaluate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluate_apprenticeship_craft = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_crafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apprenticeship_crafts/:id/evaluation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluation_apprenticeship_craft = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apprenticeship_crafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collaboration_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaboration_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /farewell_messages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const farewell_message = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"farewell_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /farewell_messages/:farewell_message_id/chats(.:format)
 * @param {any} farewell_message_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const farewell_message_chats = /*#__PURE__*/ __jsr.r({"farewell_message_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"farewell_messages"],[2,[7,"/"],[2,[3,"farewell_message_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /feature_flags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_flag = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /feature_flags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feature_flags = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /finance/periods/:id/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalize_finance_period = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"periods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/attachments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_attachment = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/attachments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_attachments = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/buckets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_bucket = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/buckets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_buckets = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"buckets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/circle_dashboards/:circle_id(.:format)
 * @param {any} circle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_circle_dashboard = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"circle_dashboards"],[2,[7,"/"],[2,[3,"circle_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_dashboard = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/gifts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_gift = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/gifts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_gifts = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"gifts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/periods/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_period = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"periods"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/periods(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_periods = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"periods"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_reimbursement_requests = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/transactions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_transaction = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"transactions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/transactions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finance_transactions = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /firebase-messaging-sw.js(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const firebase_messaging_service_worker = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"firebase-messaging-sw"],[2,[8,"."],[2,[6,"js"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gathering_absences/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_absence = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_absences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:gathering_id/gathering_invites(.:format)
 * @param {any} gathering_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_gathering_invites = /*#__PURE__*/ __jsr.r({"gathering_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"gathering_id"],[2,[7,"/"],[2,[6,"gathering_invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_invites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_invite = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:gathering_id/gathering_invites(.:format)
 * @param {any} gathering_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_invites = /*#__PURE__*/ __jsr.r({"gathering_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"gathering_id"],[2,[7,"/"],[2,[6,"gathering_invites"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gathering_map_gathering_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_map_gathering_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_map_gathering_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:gathering_id/gathering_owners(.:format)
 * @param {any} gathering_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_owners = /*#__PURE__*/ __jsr.r({"gathering_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"gathering_id"],[2,[7,"/"],[2,[6,"gathering_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:gathering_id/gathering_registered_roles(.:format)
 * @param {any} gathering_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_registered_roles = /*#__PURE__*/ __jsr.r({"gathering_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"gathering_id"],[2,[7,"/"],[2,[6,"gathering_registered_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:gathering_id/review(.:format)
 * @param {any} gathering_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_review = /*#__PURE__*/ __jsr.r({"gathering_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"gathering_id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gatherings/:gathering_id/gathering_roles_claimed(.:format)
 * @param {any} gathering_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_roles_claimed_index = /*#__PURE__*/ __jsr.r({"gathering_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[3,"gathering_id"],[2,[7,"/"],[2,[6,"gathering_roles_claimed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /gathering_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gathering_section = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id/gatherings(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gatherings_scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"gatherings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:id/guidance(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guidance_spiritual_event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"guidance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:id/inputs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inputs_care_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"inputs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:id/interact_pane/:tab(.:format)
 * @param {any} id
 * @param {any} tab
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const interact_pane_resource_upgrade_cycle_item = /*#__PURE__*/ __jsr.r({"id":{"r":true},"tab":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"interact_pane"],[2,[7,"/"],[2,[3,"tab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invitations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitation = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /invitations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitations = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gathering_invites/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invite = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_invites"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_maps/:id/iterate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iterate_care_process_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"iterate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:id/iterate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iterate_discipleship_journey_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"iterate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id/join_apprentice(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_apprentice_scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"join_apprentice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id/leave_apprentice(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_apprentice_scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"leave_apprentice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post_replies/:id/load(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const load_post_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_replies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"load"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /manifest.json(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manifest = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manifest"],[2,[8,"."],[2,[6,"json"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/actions_logs/mark_all_viewed(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_all_viewed_user_user_actions_logs = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"actions_logs"],[2,[7,"/"],[2,[6,"mark_all_viewed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/:id/mark_paid(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_paid_finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_paid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/gifts/:id/mark_processed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_processed_finance_gift = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_processed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /collaboration_members/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const member = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaboration_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /menu_buttons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const menu_button = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"menu_buttons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /menu_buttons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const menu_buttons = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"menu_buttons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /menu_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const menu_section = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"menu_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /menu_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const menu_sections = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"menu_sections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metrics = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"jobs"]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_discards(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_discards = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_discards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_retries(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_retries = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/discard(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_discard = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/dispatch(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_dispatch = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/retry(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_retry = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/:status/jobs(.:format)
 * @param {any} application_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_jobs = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:queue_id/pause(.:format)
 * @param {any} application_id
 * @param {any} queue_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_pause = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"queue_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"queue_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queues = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_task = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_tasks = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_worker = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_workers = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_job = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:status/jobs(.:format)
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_jobs = /*#__PURE__*/ __jsr.r({"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queue = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queues = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_root = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"jobs"]],[7,"/"]]);

/**
 * Generates rails route to
 * /discipleship_journey_modules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_modules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_module_completions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const module_completion = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_module_completions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_process_map_steps/:id/move_down(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_down_care_process_map_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_map_steps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teaching_guide_criteria/:id/move_down(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_down_criterium = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teaching_guide_criteria"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/passages/:passage_id/move_down(.:format)
 * @param {any} id
 * @param {any} passage_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_down_passage_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"passage_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"passages"],[2,[7,"/"],[2,[3,"passage_id"],[2,[7,"/"],[2,[6,"move_down"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_map_steps/:id/move_up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_up_care_process_map_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_map_steps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teaching_guide_criteria/:id/move_up(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_up_criterium = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teaching_guide_criteria"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/passages/:passage_id/move_up(.:format)
 * @param {any} id
 * @param {any} passage_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const move_up_passage_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"passage_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"passages"],[2,[7,"/"],[2,[3,"passage_id"],[2,[7,"/"],[2,[6,"move_up"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /buckets/:bucket_id/transactions/new(.:format)
 * @param {any} bucket_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bucket_transaction = /*#__PURE__*/ __jsr.r({"bucket_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[3,"bucket_id"],[2,[7,"/"],[2,[6,"transactions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /circles/:circle_id/roles/new(.:format)
 * @param {any} circle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_circle_role = /*#__PURE__*/ __jsr.r({"circle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[3,"circle_id"],[2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /components/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_component = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /crafts/:craft_id/craft_resources/new(.:format)
 * @param {any} craft_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_craft_craft_resource = /*#__PURE__*/ __jsr.r({"craft_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[3,"craft_id"],[2,[7,"/"],[2,[6,"craft_resources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/decision_input_points/new(.:format)
 * @param {any} decision_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_decision_decision_input_point = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"decision_input_points"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:decision_id/decision_questions/new(.:format)
 * @param {any} decision_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_decision_decision_question = /*#__PURE__*/ __jsr.r({"decision_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"decision_id"],[2,[7,"/"],[2,[6,"decision_questions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_discipleship_journey_map = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_modules/new(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_discipleship_journey_map_module = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_modules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:discipleship_journey_map_id/discipleship_journey_map_roles/new(.:format)
 * @param {any} discipleship_journey_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_discipleship_journey_map_role = /*#__PURE__*/ __jsr.r({"discipleship_journey_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"discipleship_journey_map_id"],[2,[7,"/"],[2,[6,"discipleship_journey_map_roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /drawer_buttons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_drawer_button = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"drawer_buttons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/apprenticeships/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_apprenticeship = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"apprenticeships"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/buckets/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_bucket = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/care_process_maps/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_care_process_map = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/circles/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_circle = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"circles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/circle_types/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_circle_type = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"circle_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/collaborations/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_collaboration = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"collaborations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/crafts/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_craft = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/discipleship_journeys/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_discipleship_journey = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"discipleship_journeys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gatherings/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_gathering = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gatherings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/gathering_maps/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_gathering_map = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"gathering_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pilgramage_maps/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_pilgramage_map = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pilgramage_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/pulses/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_pulse = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"pulses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/resources/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_resource = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/role_types/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_role_type = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"role_types"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_digs/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_scripture_dig = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_digs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_dig_info_pages/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_scripture_dig_info_page = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_dig_info_pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_dig_maps/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_scripture_dig_map = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_dig_tools/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_scripture_dig_tool = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_dig_tools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_imports/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_scripture_import = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/scripture_study_maps/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_scripture_study_map = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"scripture_study_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/ecosystem_seasons/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_season = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"ecosystem_seasons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/skill_models/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_skill_model = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"skill_models"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/spiritual_events/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_spiritual_event = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/spiritual_event_tools/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_spiritual_event_tool = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"spiritual_event_tools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/spiritual_practice_milestones/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_spiritual_practice_milestone = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"spiritual_practice_milestones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/teaching_guides/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_teaching_guide = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"teaching_guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/training_maps/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_training_map = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/training_trees/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_training_tree = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"training_trees"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/users/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_user = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/user_challenges/new(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_ecosystem_user_challenge = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"user_challenges"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /feature_flags/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_feature_flag = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/buckets/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_finance_bucket = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"buckets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/gifts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_finance_gift = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"gifts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/periods/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_finance_period = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"periods"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/transactions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_finance_transaction = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"transactions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /menu_buttons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_menu_button = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"menu_buttons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_notification = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/new_passage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_passage_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_passage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_post = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prayer_requests/:prayer_request_id/prayer_request_updates/new(.:format)
 * @param {any} prayer_request_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_prayer_request_prayer_request_update = /*#__PURE__*/ __jsr.r({"prayer_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_requests"],[2,[7,"/"],[2,[3,"prayer_request_id"],[2,[7,"/"],[2,[6,"prayer_request_updates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_entries/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_spiritual_practice_entry = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_trees/:training_tree_id/training_groups/new(.:format)
 * @param {any} training_tree_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_training_tree_training_group = /*#__PURE__*/ __jsr.r({"training_tree_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_trees"],[2,[7,"/"],[2,[3,"training_tree_id"],[2,[7,"/"],[2,[6,"training_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /care_inputs/:id/no_action(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const no_action_care_input = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_inputs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"no_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const note = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notes = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notification_flags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_flag = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notification_flags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:notification_id/tokens/:id(.:format)
 * @param {any} notification_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_token = /*#__PURE__*/ __jsr.r({"notification_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"notification_id"],[2,[7,"/"],[2,[6,"tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/:notification_id/tokens(.:format)
 * @param {any} notification_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notification_tokens = /*#__PURE__*/ __jsr.r({"notification_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"notification_id"],[2,[7,"/"],[2,[6,"tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gathering_owners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const owner = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_owners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ownerships/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ownership = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ownerships"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/passages/:passage_id(.:format)
 * @param {any} id
 * @param {any} passage_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const passage_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"passage_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"passages"],[2,[7,"/"],[2,[3,"passage_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /care_processes/:id/people(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_care_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_processes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /people_processes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_process = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_processes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people_process_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_process_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_process_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people_process_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_process_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_process_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /people_process_step_owners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_process_step_owner = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_process_step_owners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id/people(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const people_scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pilgramages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_activities/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_activity = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_activities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_maps/:pilgramage_map_id/pilgramage_map_steps(.:format)
 * @param {any} pilgramage_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_map_pilgramage_map_steps = /*#__PURE__*/ __jsr.r({"pilgramage_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_maps"],[2,[7,"/"],[2,[3,"pilgramage_map_id"],[2,[7,"/"],[2,[6,"pilgramage_map_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_maps/:pilgramage_map_id/pilgramage_map_teachings(.:format)
 * @param {any} pilgramage_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_map_pilgramage_map_teachings = /*#__PURE__*/ __jsr.r({"pilgramage_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_maps"],[2,[7,"/"],[2,[3,"pilgramage_map_id"],[2,[7,"/"],[2,[6,"pilgramage_map_teachings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_map_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_map_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_map_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_map_teachings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_map_teaching = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_map_teachings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_steps/:pilgramage_step_id/chats(.:format)
 * @param {any} pilgramage_step_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_step_chats = /*#__PURE__*/ __jsr.r({"pilgramage_step_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_steps"],[2,[7,"/"],[2,[3,"pilgramage_step_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_step_completions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_step_completion = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_step_completions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_teachings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_teaching = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_teachings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_teachings/:pilgramage_teaching_id/chats(.:format)
 * @param {any} pilgramage_teaching_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_teaching_chats = /*#__PURE__*/ __jsr.r({"pilgramage_teaching_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_teachings"],[2,[7,"/"],[2,[3,"pilgramage_teaching_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_teaching_completions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_teaching_completion = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_teaching_completions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pilgramage_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pilgramage_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pilgramage_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /decisions/:id/ping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ping_decision = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"decisions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /farewell_messages/:id/ping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ping_farewell_message = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"farewell_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/ping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ping_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_digs/:id/place_tool(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const place_tool_scripture_dig = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_digs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"place_tool"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:id/place_tool(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const place_tool_spiritual_event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"place_tool"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/post_replies(.:format)
 * @param {any} post_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_post_replies = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"post_replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post_replies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const post_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_replies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posts = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /practices_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const practices_stats = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"practices_stats"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /practices_summary(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const practices_summary = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"practices_summary"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /prayer_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prayer_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prayer_requests/:prayer_request_id/prayer_request_updates(.:format)
 * @param {any} prayer_request_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prayer_request_prayer_request_updates = /*#__PURE__*/ __jsr.r({"prayer_request_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_requests"],[2,[7,"/"],[2,[3,"prayer_request_id"],[2,[7,"/"],[2,[6,"prayer_request_updates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /prayer_request_updates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prayer_request_update = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_request_updates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prayer_request_viewers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prayer_request_viewer = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_request_viewers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prayer_sessions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prayer_session = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"prayer_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /process_templates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_template = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"process_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /process_templates/:process_template_id/process_template_steps(.:format)
 * @param {any} process_template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_template_process_template_steps = /*#__PURE__*/ __jsr.r({"process_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"process_templates"],[2,[7,"/"],[2,[3,"process_template_id"],[2,[7,"/"],[2,[6,"process_template_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /process_template_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_template_step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"process_template_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /process_templates/:process_template_id/process_template_steps(.:format)
 * @param {any} process_template_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const process_template_steps = /*#__PURE__*/ __jsr.r({"process_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"process_templates"],[2,[7,"/"],[2,[3,"process_template_id"],[2,[7,"/"],[2,[6,"process_template_steps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id/profile_picture(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_picture_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"profile_picture"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_spiritual_event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pulses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pulse = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pulses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pulses/:pulse_id/menu/:panel(.:format)
 * @param {any} pulse_id
 * @param {any} panel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pulse_menu = /*#__PURE__*/ __jsr.r({"pulse_id":{"r":true},"panel":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pulses"],[2,[7,"/"],[2,[3,"pulse_id"],[2,[7,"/"],[2,[6,"menu"],[2,[7,"/"],[2,[3,"panel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /components/:component_id/component_fields/:field_id/component_data/:id/purge_attachment(.:format)
 * @param {any} component_id
 * @param {any} field_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purge_attachment_component_field_datum = /*#__PURE__*/ __jsr.r({"component_id":{"r":true},"field_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[3,"component_id"],[2,[7,"/"],[2,[6,"component_fields"],[2,[7,"/"],[2,[3,"field_id"],[2,[7,"/"],[2,[6,"component_data"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purge_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_entries/:id/purge_photo(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purge_photo_spiritual_practice_entry = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"purge_photo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflections/:id/push_live(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const push_live_scripture_study_reflection = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"push_live"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflection_evaluations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reflection_evaluation = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflection_evaluations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflection_impacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reflection_impact = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflection_impacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflection_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reflection_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflection_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gathering_registered_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registered_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_registered_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /registrations/convert_external_user(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registrations_convert_external_user = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"registrations"],[2,[7,"/"],[2,[6,"convert_external_user"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /feature_flags/:id/remove_entry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_entry_feature_flag = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_entry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/remove_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_token_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"remove_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_digs/:id/remove_tool(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_tool_scripture_dig = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_digs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_tool"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:id/remove_tool(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_tool_spiritual_event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_tool"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/periods/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_finance_period = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"periods"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_resource_upgrade_cycle_item = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_execution_debriefs/:id/reopen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reopen_training_execution_debrief = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_execution_debriefs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resources/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resources"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_editors/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_editor = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_editors"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_item = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:resource_upgrade_cycle_item_id/chats(.:format)
 * @param {any} resource_upgrade_cycle_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_item_chats = /*#__PURE__*/ __jsr.r({"resource_upgrade_cycle_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"resource_upgrade_cycle_item_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:resource_upgrade_cycle_item_id/resource_upgrade_cycle_editors(.:format)
 * @param {any} resource_upgrade_cycle_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_item_resource_upgrade_cycle_editors = /*#__PURE__*/ __jsr.r({"resource_upgrade_cycle_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"resource_upgrade_cycle_item_id"],[2,[7,"/"],[2,[6,"resource_upgrade_cycle_editors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:resource_upgrade_cycle_item_id/resource_upgrade_cycle_reviews(.:format)
 * @param {any} resource_upgrade_cycle_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_item_resource_upgrade_cycle_reviews = /*#__PURE__*/ __jsr.r({"resource_upgrade_cycle_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"resource_upgrade_cycle_item_id"],[2,[7,"/"],[2,[6,"resource_upgrade_cycle_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycles/:resource_upgrade_cycle_id/resource_upgrade_cycle_items(.:format)
 * @param {any} resource_upgrade_cycle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_resource_upgrade_cycle_items = /*#__PURE__*/ __jsr.r({"resource_upgrade_cycle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycles"],[2,[7,"/"],[2,[3,"resource_upgrade_cycle_id"],[2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycles/:resource_upgrade_cycle_id/resource_upgrade_cycle_reviewers(.:format)
 * @param {any} resource_upgrade_cycle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_resource_upgrade_cycle_reviewers = /*#__PURE__*/ __jsr.r({"resource_upgrade_cycle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycles"],[2,[7,"/"],[2,[3,"resource_upgrade_cycle_id"],[2,[7,"/"],[2,[6,"resource_upgrade_cycle_reviewers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_reviewers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resource_upgrade_cycle_reviewer = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_reviewers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /role_types/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_type = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /role_type_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_type_item = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_type_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /role_types/:role_type_id/role_type_items(.:format)
 * @param {any} role_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_type_role_type_items = /*#__PURE__*/ __jsr.r({"role_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_types"],[2,[7,"/"],[2,[3,"role_type_id"],[2,[7,"/"],[2,[6,"role_type_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /role_types/:role_type_id/role_type_user_kinds(.:format)
 * @param {any} role_type_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_type_role_type_user_kinds = /*#__PURE__*/ __jsr.r({"role_type_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_types"],[2,[7,"/"],[2,[3,"role_type_id"],[2,[7,"/"],[2,[6,"role_type_user_kinds"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /role_type_user_kinds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const role_type_user_kind = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"role_type_user_kinds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /gathering_roles_claimed/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const roles_claimed = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"gathering_roles_claimed"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discipleship_journey_maps/:id/rollback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rollback_discipleship_journey_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"discipleship_journey_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rollback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /scan/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanner = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scan"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scan/:id/verify_url(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scanner_verify_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scan"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_notifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduled_notification = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scheduled_notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scheduled_notifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduled_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"scheduled_notifications"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scripture_chapters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_chapter = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_chapters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_digs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_digs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_info_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_info_page = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_info_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_info_page_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_info_page_link = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_info_page_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_digs/:scripture_dig_id/progress(.:format)
 * @param {any} scripture_dig_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_progress = /*#__PURE__*/ __jsr.r({"scripture_dig_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_digs"],[2,[7,"/"],[2,[3,"scripture_dig_id"],[2,[7,"/"],[2,[6,"progress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_digs/:scripture_dig_id/scripture_dig_tool_placements(.:format)
 * @param {any} scripture_dig_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_scripture_dig_tool_placements = /*#__PURE__*/ __jsr.r({"scripture_dig_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_digs"],[2,[7,"/"],[2,[3,"scripture_dig_id"],[2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_tool = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_tool_placement = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placements/:scripture_dig_tool_placement_id/new_info_page/:page_type(.:format)
 * @param {any} scripture_dig_tool_placement_id
 * @param {any} page_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_tool_placement_new_info_page = /*#__PURE__*/ __jsr.r({"scripture_dig_tool_placement_id":{"r":true},"page_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[2,[7,"/"],[2,[3,"scripture_dig_tool_placement_id"],[2,[7,"/"],[2,[6,"new_info_page"],[2,[7,"/"],[2,[3,"page_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placement_replies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_tool_placement_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placement_replies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placements/:scripture_dig_tool_placement_id/save(.:format)
 * @param {any} scripture_dig_tool_placement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_tool_placement_save = /*#__PURE__*/ __jsr.r({"scripture_dig_tool_placement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[2,[7,"/"],[2,[3,"scripture_dig_tool_placement_id"],[2,[7,"/"],[2,[6,"save"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placements/:scripture_dig_tool_placement_id/scripture_dig_info_page_links(.:format)
 * @param {any} scripture_dig_tool_placement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_tool_placement_scripture_dig_info_page_links = /*#__PURE__*/ __jsr.r({"scripture_dig_tool_placement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[2,[7,"/"],[2,[3,"scripture_dig_tool_placement_id"],[2,[7,"/"],[2,[6,"scripture_dig_info_page_links"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tool_placements/:scripture_dig_tool_placement_id/scripture_dig_tool_placement_replies(.:format)
 * @param {any} scripture_dig_tool_placement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_dig_tool_placement_scripture_dig_tool_placement_replies = /*#__PURE__*/ __jsr.r({"scripture_dig_tool_placement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tool_placements"],[2,[7,"/"],[2,[3,"scripture_dig_tool_placement_id"],[2,[7,"/"],[2,[6,"scripture_dig_tool_placement_replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_contents/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_content = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_contents/:scripture_study_content_id/scripture_study_content_completions(.:format)
 * @param {any} scripture_study_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_content_completions = /*#__PURE__*/ __jsr.r({"scripture_study_content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_contents"],[2,[7,"/"],[2,[3,"scripture_study_content_id"],[2,[7,"/"],[2,[6,"scripture_study_content_completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_contents/:scripture_study_content_id/scripture_study_content_users(.:format)
 * @param {any} scripture_study_content_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_content_content_users = /*#__PURE__*/ __jsr.r({"scripture_study_content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_contents"],[2,[7,"/"],[2,[3,"scripture_study_content_id"],[2,[7,"/"],[2,[6,"scripture_study_content_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_content_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_content_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_content_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_maps/:scripture_study_map_id/scripture_study_map_contents(.:format)
 * @param {any} scripture_study_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_map_contents = /*#__PURE__*/ __jsr.r({"scripture_study_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_maps"],[2,[7,"/"],[2,[3,"scripture_study_map_id"],[2,[7,"/"],[2,[6,"scripture_study_map_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_maps/:scripture_study_map_id/scripture_study_map_dig_maps(.:format)
 * @param {any} scripture_study_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_map_dig_maps = /*#__PURE__*/ __jsr.r({"scripture_study_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_maps"],[2,[7,"/"],[2,[3,"scripture_study_map_id"],[2,[7,"/"],[2,[6,"scripture_study_map_dig_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_reflection = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflection_impacts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_reflection_impact = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflection_impacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflections/:scripture_study_reflection_id/scripture_study_reflection_evaluations(.:format)
 * @param {any} scripture_study_reflection_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_reflection_reflection_evaluations = /*#__PURE__*/ __jsr.r({"scripture_study_reflection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflections"],[2,[7,"/"],[2,[3,"scripture_study_reflection_id"],[2,[7,"/"],[2,[6,"scripture_study_reflection_evaluations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflections/:scripture_study_reflection_id/scripture_study_reflection_impacts(.:format)
 * @param {any} scripture_study_reflection_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_reflection_reflection_impacts = /*#__PURE__*/ __jsr.r({"scripture_study_reflection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflections"],[2,[7,"/"],[2,[3,"scripture_study_reflection_id"],[2,[7,"/"],[2,[6,"scripture_study_reflection_impacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflections/:scripture_study_reflection_id/scripture_study_reflection_users(.:format)
 * @param {any} scripture_study_reflection_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_reflection_reflection_users = /*#__PURE__*/ __jsr.r({"scripture_study_reflection_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflections"],[2,[7,"/"],[2,[3,"scripture_study_reflection_id"],[2,[7,"/"],[2,[6,"scripture_study_reflection_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_reflection_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_reflection_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_reflection_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:scripture_study_id/scripture_study_reflections(.:format)
 * @param {any} scripture_study_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_scripture_study_reflections = /*#__PURE__*/ __jsr.r({"scripture_study_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"scripture_study_id"],[2,[7,"/"],[2,[6,"scripture_study_reflections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /scripture_studies/:scripture_study_id/scripture_study_users(.:format)
 * @param {any} scripture_study_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scripture_study_users = /*#__PURE__*/ __jsr.r({"scripture_study_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_studies"],[2,[7,"/"],[2,[3,"scripture_study_id"],[2,[7,"/"],[2,[6,"scripture_study_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ecosystem_seasons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const season = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystem_seasons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ecosystem_seasons/:season_id/ecosystem_season_video_checks(.:format)
 * @param {any} season_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const season_video_checks = /*#__PURE__*/ __jsr.r({"season_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystem_seasons"],[2,[7,"/"],[2,[3,"season_id"],[2,[7,"/"],[2,[6,"ecosystem_season_video_checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /crafts/:id/select_apprenticeship_craft(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const select_apprenticeship_craft_craft = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"crafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_apprenticeship_craft"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/send(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sessions/impersonate/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sessions_impersonate = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"impersonate"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /state_machines/show/:target_id/:target_type(.:format)
 * @param {any} target_id
 * @param {any} target_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_state_machines = /*#__PURE__*/ __jsr.r({"target_id":{"r":true},"target_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"state_machines"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"target_id"],[2,[7,"/"],[2,[3,"target_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tags/show/:target_id(.:format)
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_tags = /*#__PURE__*/ __jsr.r({"target_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /timegated/show/:target_id/:target_type(.:format)
 * @param {any} target_id
 * @param {any} target_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const show_timegated_index = /*#__PURE__*/ __jsr.r({"target_id":{"r":true},"target_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timegated"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"target_id"],[2,[7,"/"],[2,[3,"target_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /skill_models/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const skill_model = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"skill_models"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:spiritual_event_id/spiritual_event_syntheses(.:format)
 * @param {any} spiritual_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event_spiritual_event_syntheses = /*#__PURE__*/ __jsr.r({"spiritual_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"spiritual_event_id"],[2,[7,"/"],[2,[6,"spiritual_event_syntheses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_events/:spiritual_event_id/spiritual_event_tool_placements(.:format)
 * @param {any} spiritual_event_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event_spiritual_event_tool_placements = /*#__PURE__*/ __jsr.r({"spiritual_event_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_events"],[2,[7,"/"],[2,[3,"spiritual_event_id"],[2,[7,"/"],[2,[6,"spiritual_event_tool_placements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_syntheses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event_synthesis = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_syntheses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tools/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event_tool = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tool_placements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event_tool_placement = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tool_placements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tool_placement_replies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event_tool_placement_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tool_placement_replies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tool_placements/:spiritual_event_tool_placement_id/spiritual_event_tool_placement_replies(.:format)
 * @param {any} spiritual_event_tool_placement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_event_tool_placement_spiritual_event_tool_placement_replies = /*#__PURE__*/ __jsr.r({"spiritual_event_tool_placement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tool_placements"],[2,[7,"/"],[2,[3,"spiritual_event_tool_placement_id"],[2,[7,"/"],[2,[6,"spiritual_event_tool_placement_replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practices/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_practice = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_entries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_practice_entries = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_entries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_entries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_practice_entry = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_milestones/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_practice_milestone = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_milestones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practice_milestone_awards/:spiritual_practice_milestone_award_id/chats(.:format)
 * @param {any} spiritual_practice_milestone_award_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_practice_milestone_award_chats = /*#__PURE__*/ __jsr.r({"spiritual_practice_milestone_award_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practice_milestone_awards"],[2,[7,"/"],[2,[3,"spiritual_practice_milestone_award_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practices_rules/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_practices_rule = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practices_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_practices_rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const spiritual_practices_rules = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spiritual_practices_rules"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /process_template_steps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const step = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"process_template_steps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /style(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const style_guide = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"style"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /finance/reimbursement_requests/:id/submit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_finance_reimbursement_request = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"finance"],[2,[7,"/"],[2,[6,"reimbursement_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /resource_upgrade_cycle_items/:id/submit_for_review(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_for_review_resource_upgrade_cycle_item = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"resource_upgrade_cycle_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_for_review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /post_replies/:id/submit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const submit_post_reply = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"post_replies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notification_preferences/subscribe_email(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_email_user_notification_preferences = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notification_preferences"],[2,[7,"/"],[2,[6,"subscribe_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tag = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /teaching_guides/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaching_guide = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teaching_guides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teaching_guides/:teaching_guide_id/teaching_guide_criteria(.:format)
 * @param {any} teaching_guide_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaching_guide_criteria = /*#__PURE__*/ __jsr.r({"teaching_guide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teaching_guides"],[2,[7,"/"],[2,[3,"teaching_guide_id"],[2,[7,"/"],[2,[6,"teaching_guide_criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_tools/:id/toggle_active(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_active_scripture_dig_tool = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /spiritual_event_tools/:id/toggle_active(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_active_spiritual_event_tool = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"spiritual_event_tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /teaching_guide_criteria/:id/toggle_rating(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_rating_criterium = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"teaching_guide_criteria"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_rating"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_maps/:id/toggle_release(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_release_care_process_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_maps/:id/toggle_release(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_release_scripture_study_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:id/toggle_release(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_release_training_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_release"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:id/toggle_reply_subscription(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_reply_subscription_post = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_reply_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_study_contents/:id/toggle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_scripture_study_content = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_study_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_dig_maps/:id/toggle_tool(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_tool_scripture_dig_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_dig_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_tool"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:training_id/chats(.:format)
 * @param {any} training_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_chats = /*#__PURE__*/ __jsr.r({"training_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"training_id"],[2,[7,"/"],[2,[6,"chats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_content_debrief_checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_content_debrief_check = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_content_debrief_checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_execution_debriefs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_execution_debrief = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_execution_debriefs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_execution_debrief_trainees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_execution_debrief_trainee = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_execution_debrief_trainees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_execution_debriefs/:training_execution_debrief_id/training_execution_debrief_trainees(.:format)
 * @param {any} training_execution_debrief_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_execution_debrief_training_execution_debrief_trainees = /*#__PURE__*/ __jsr.r({"training_execution_debrief_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_execution_debriefs"],[2,[7,"/"],[2,[3,"training_execution_debrief_id"],[2,[7,"/"],[2,[6,"training_execution_debrief_trainees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_grants/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_grant = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_grants"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_group = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:training_map_id/training_map_attachments(.:format)
 * @param {any} training_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map_attachments = /*#__PURE__*/ __jsr.r({"training_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"training_map_id"],[2,[7,"/"],[2,[6,"training_map_attachments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_map_debrief_points/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map_debrief_point = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_map_debrief_points"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:training_map_id/training_map_editors(.:format)
 * @param {any} training_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map_editors = /*#__PURE__*/ __jsr.r({"training_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"training_map_id"],[2,[7,"/"],[2,[6,"training_map_editors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_map_gathering_roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map_gathering_role = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_map_gathering_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_map_skill_models/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map_skill_model = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_map_skill_models"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:training_map_id/training_map_debrief_points(.:format)
 * @param {any} training_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map_training_map_debrief_points = /*#__PURE__*/ __jsr.r({"training_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"training_map_id"],[2,[7,"/"],[2,[6,"training_map_debrief_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_maps/:training_map_id/training_map_gathering_roles(.:format)
 * @param {any} training_map_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_map_training_map_gathering_roles = /*#__PURE__*/ __jsr.r({"training_map_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_maps"],[2,[7,"/"],[2,[3,"training_map_id"],[2,[7,"/"],[2,[6,"training_map_gathering_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_notification_preferences/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_notification_preference = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_notification_preferences"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:training_id/training_completions(.:format)
 * @param {any} training_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_training_completions = /*#__PURE__*/ __jsr.r({"training_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"training_id"],[2,[7,"/"],[2,[6,"training_completions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:training_id/training_content_debrief_checks(.:format)
 * @param {any} training_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_training_content_debrief_checks = /*#__PURE__*/ __jsr.r({"training_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"training_id"],[2,[7,"/"],[2,[6,"training_content_debrief_checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:training_id/training_execution_debriefs(.:format)
 * @param {any} training_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_training_execution_debriefs = /*#__PURE__*/ __jsr.r({"training_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"training_id"],[2,[7,"/"],[2,[6,"training_execution_debriefs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:training_id/training_grants(.:format)
 * @param {any} training_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_training_grants = /*#__PURE__*/ __jsr.r({"training_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"training_id"],[2,[7,"/"],[2,[6,"training_grants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /trainings/:training_id/training_users(.:format)
 * @param {any} training_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_training_users = /*#__PURE__*/ __jsr.r({"training_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"trainings"],[2,[7,"/"],[2,[3,"training_id"],[2,[7,"/"],[2,[6,"training_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_trees/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_tree = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_trees"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /training_trees/:training_tree_id/training_groups(.:format)
 * @param {any} training_tree_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_tree_training_groups = /*#__PURE__*/ __jsr.r({"training_tree_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_trees"],[2,[7,"/"],[2,[3,"training_tree_id"],[2,[7,"/"],[2,[6,"training_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /training_users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const training_user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"training_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /transactions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transaction = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"transactions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ecosystems/:ecosystem_id/prayer_sessions/tutorial(.:format)
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tutorial_ecosystem_prayer_sessions = /*#__PURE__*/ __jsr.r({"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ecosystems"],[2,[7,"/"],[2,[3,"ecosystem_id"],[2,[7,"/"],[2,[6,"prayer_sessions"],[2,[7,"/"],[2,[6,"tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/unsubscribe_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_all_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"unsubscribe_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notification_preferences/unsubscribe_email(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_email_user_notification_preferences = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notification_preferences"],[2,[7,"/"],[2,[6,"unsubscribe_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /notifications/unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_notifications = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const up = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /state_machines/update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_state_machines = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"state_machines"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /timegated/update/:target_id/:target_type(.:format)
 * @param {any} target_id
 * @param {any} target_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_timegated_index = /*#__PURE__*/ __jsr.r({"target_id":{"r":true},"target_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"timegated"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"target_id"],[2,[7,"/"],[2,[3,"target_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /scripture_chapters/:id/verses/:verse_id(.:format)
 * @param {any} id
 * @param {any} verse_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_verse_scripture_chapter = /*#__PURE__*/ __jsr.r({"id":{"r":true},"verse_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_chapters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verses"],[2,[7,"/"],[2,[3,"verse_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /invitations/update_visibility(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_visibility_invitations = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[6,"update_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /components/updates_badge/:target_id(.:format)
 * @param {any} target_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_badge_components = /*#__PURE__*/ __jsr.r({"target_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"components"],[2,[7,"/"],[2,[6,"updates_badge"],[2,[7,"/"],[2,[3,"target_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /care_process_maps/:id/upload_banner(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_banner_care_process_map = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"care_process_maps"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload_banner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_actions_logs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_actions_logs = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_actions_logs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /user_challenges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_challenge = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_challenges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_challenge_targets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_challenge_target = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_challenge_targets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_challenges/:user_challenge_id/user_challenge_targets(.:format)
 * @param {any} user_challenge_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_challenge_user_challenge_targets = /*#__PURE__*/ __jsr.r({"user_challenge_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_challenges"],[2,[7,"/"],[2,[3,"user_challenge_id"],[2,[7,"/"],[2,[6,"user_challenge_targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /user_empowerments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_empowerment = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_empowerments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_kinds/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_kind = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_kinds"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /user_kind_assignments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_kind_assignment = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"user_kind_assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/notification_preferences(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_notification_preferences = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"notification_preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/ownerships(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_ownerships = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"ownerships"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/partial/:partial/:ecosystem_id(.:format)
 * @param {any} user_id
 * @param {any} partial
 * @param {any} ecosystem_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_partial = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"partial":{"r":true},"ecosystem_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"partial"],[2,[7,"/"],[2,[3,"partial"],[2,[7,"/"],[2,[3,"ecosystem_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /auth/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/:user_id/actions_logs(.:format)
 * @param {any} user_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_user_actions_logs = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"actions_logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /scripture_chapters/:id/verses(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verses_scripture_chapter = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"scripture_chapters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /webflow/head_inner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webflow_head_inner = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webflow"],[2,[7,"/"],[2,[6,"head_inner"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /webflow/*slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webflow_proxy = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webflow"],[2,[7,"/"],[2,[5,[3,"slug"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

